/**
 * Permission codes of the budget transfer screens (FSD 2.2.5 FIN-F06 V05).
 *
 * The dot-strings `internal/budget/permissions.go` registers for
 * `GET /budget-transfers` and the register report (`read`) and `POST /budget-transfers`
 * (`request`). Requesting is not approving: the decision is made in the Approvals Inbox by
 * someone else, so no decision permission lives here.
 */
export const BUDGET_TRANSFER_PERMISSIONS = {
  read: 'budget.transfer.read',
  request: 'budget.transfer.request',
} as const
